import { Box, Grid, Stack } from '@mui/material'
import times from 'lodash/times'
import { ReactNode } from 'react'
import { StyledSkeleton } from '@omnea-app/frontend/components/layout/skeleton/StyledSkeleton'

interface RowProps {
  children: ReactNode
  sx?: Partial<{ backgroundColor: string; borderRadius: string; borderBottom: string; borderBottomColor: string }>
}

const StyledRow = ({ children, sx }: RowProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        height: 48,
        width: '100%',
        px: 6,
        overflow: 'hidden',
        ...sx,
      }}
    >
      <Grid
        container
        sx={{
          display: 'grid',
          gridAutoFlow: 'column',
          gridGap: 8,
          overflow: 'hidden',
        }}
      >
        {children}
      </Grid>
    </Box>
  )
}

export const DataGridLoading = ({ hasUncontainedTableStyling }: { hasUncontainedTableStyling?: boolean }) => {
  return (
    <Stack sx={{ height: 'auto', width: '100%' }}>
      {hasUncontainedTableStyling && (
        <Stack flexDirection="row" justifyContent="space-between" sx={{ py: '20px' }}>
          <Stack flexDirection="row" gap={2} sx={{ flexGrow: 1, maxWidth: 544, pr: 8 }}>
            {times(4).map((_, i) => (
              <StyledSkeleton key={i} height={32} sx={{ flexGrow: 1, maxWidth: 104 }} />
            ))}
          </Stack>
          <Stack flexDirection="row">
            <StyledSkeleton height={32} width={106} />
          </Stack>
        </Stack>
      )}
      <Stack>
        {hasUncontainedTableStyling && (
          <StyledRow sx={{ backgroundColor: 'bg.surface.default', borderRadius: '8px 8px 0px 0px' }}>
            <Stack direction="row" sx={{ justifyContent: 'space-between' }}>
              <Stack direction="row" gap={4}>
                {times(4).map((_, i) => (
                  <Box key={i} maxWidth={173} sx={{ backgroundColor: 'bg.surface.default' }}>
                    <StyledSkeleton height={24} width={64} />
                  </Box>
                ))}
              </Stack>
              <Box sx={{ backgroundColor: 'bg.surface.default' }}>
                <StyledSkeleton height={24} width={180} />
              </Box>
            </Stack>
          </StyledRow>
        )}
        <StyledRow
          sx={{
            backgroundColor: 'bg.surface.subtle',
            borderRadius: `${hasUncontainedTableStyling ? 0 : 8}px ${hasUncontainedTableStyling ? 0 : 8}px 0px 0px`,
          }}
        >
          {times(4).map((_, i) => (
            <StyledSkeleton key={i} height={12} sx={{ width: 80 }} />
          ))}
        </StyledRow>
        {times(4).map((_, i) => (
          <StyledRow
            key={i}
            sx={{
              backgroundColor: 'bg.surface.default',
              borderBottom: '1px solid',
              borderBottomColor: 'border.subtle',
              borderRadius: `0px 0px ${i === 4 - 1 ? 8 : 0}px ${i === 4 - 1 ? 8 : 0}px`,
            }}
          >
            {times(4).map((_, i) => (
              <StyledSkeleton key={i} height={16} sx={{ width: 173 }} />
            ))}
          </StyledRow>
        ))}
      </Stack>
    </Stack>
  )
}
